/**
 * Tabblad Stellingen: stellingen aanmaken en verwijderen, en per stelling
 * de bronnen beheren (onderdelen/BronnenBeheer.js).
 */
import React, { useEffect, useState } from 'react';
import { Plus, Save } from 'lucide-react';
import { basis } from '../stijlen';
import { StellingenLijst } from '../../../components/StellingenLijst';
import { BronnenBeheer } from '../onderdelen/BronnenBeheer';

export function Stellingen({ api, user }) {
  const [stellingen, setStellingen] = useState([]);
  const [laden, setLaden] = useState(false);
  const [gekozen, setGekozen] = useState(null);
  const [toonForm, setToonForm] = useState(false);
  const [nieuw, setNieuw] = useState({ titel: '', beschrijving: '' });

  const haalLijst = async () => {
    setLaden(true);
    try {
      const data = await api.haalStellingen();
      if (data.success) setStellingen(data.data);
    } catch (err) { console.error('Fout:', err); }
    finally { setLaden(false); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { haalLijst(); }, []);

  const bekijk = async (id) => {
    try {
      const data = await api.haalStelling(id);
      if (data.success) setGekozen(data.data);
    } catch (err) { console.error('Fout:', err); }
  };

  const maak = async (e) => {
    e.preventDefault();
    try {
      const data = await api.maakStelling(nieuw.titel, nieuw.beschrijving, user.id);
      if (data.success) { setNieuw({ titel: '', beschrijving: '' }); setToonForm(false); haalLijst(); }
    } catch (err) { console.error('Fout:', err); }
  };

  const verwijder = async (id) => {
    if (!window.confirm('Weet je zeker?')) return;
    try {
      const data = await api.verwijderStelling(id);
      if (data.success) { haalLijst(); setGekozen(null); }
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.splitView}>
      <StellingenLijst titel="De stellingen" stellingen={stellingen} laden={laden} geselecteerdId={gekozen?.id}
        onKies={bekijk} onVerwijder={verwijder} leegTekst="Nog geen stellingen." stijlen={styles}
        knop={<button onClick={() => setToonForm(true)} style={styles.addBtn}><Plus size={16} /> Nieuwe Stelling</button>}>
        {toonForm && (
          <form onSubmit={maak} style={styles.form}>
            <input type="text" placeholder="Stelling" value={nieuw.titel} onChange={(e) => setNieuw({ ...nieuw, titel: e.target.value })} style={styles.input} required />
            <textarea placeholder="Beschrijving" value={nieuw.beschrijving} onChange={(e) => setNieuw({ ...nieuw, beschrijving: e.target.value })} style={{ ...styles.input, minHeight: '80px' }} />
            <div style={styles.formButtons}>
              <button type="submit" style={styles.saveBtn}><Save size={16} /> Opslaan</button>
              <button type="button" onClick={() => setToonForm(false)} style={styles.cancelBtn}>Annuleren</button>
            </div>
          </form>
        )}
      </StellingenLijst>
      <div style={styles.detailPanel}>
        {gekozen ? (
          <>
            <h2>{gekozen.titel}</h2>
            {gekozen.beschrijving && <p style={styles.beschrijving}>{gekozen.beschrijving}</p>}
            <BronnenBeheer key={gekozen.id} api={api} stelling={gekozen} onHerlaad={() => bekijk(gekozen.id)} />
          </>
        ) : <p style={styles.empty}>Selecteer een stelling</p>}
      </div>
    </div>
  );
}

const styles = { ...basis };
